var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5959 8.27601V15.7237C21.5959 16.9432 20.9426 18.0757 19.8865 18.6963L13.4187 22.4311C12.3625 23.0408 11.0559 23.0408 9.9888 22.4311L3.52102 18.6963C2.46483 18.0866 1.81152 16.9541 1.81152 15.7237V8.27601C1.81152 7.05649 2.46483 5.92404 3.52102 5.3034L9.9888 1.56865C11.045 0.958889 12.3516 0.958889 13.4187 1.56865L19.8865 5.3034C20.9426 5.92404 21.5959 7.0456 21.5959 8.27601Z",
    stroke: "white",
    strokeWidth: 1.63328,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7035 11.4998C12.9904 11.4998 14.0335 10.4566 14.0335 9.1698C14.0335 7.88298 12.9904 6.83984 11.7035 6.83984C10.4167 6.83984 9.37354 7.88298 9.37354 9.1698C9.37354 10.4566 10.4167 11.4998 11.7035 11.4998Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7036 17.1603C15.7036 15.3603 13.9136 13.9004 11.7036 13.9004C9.49361 13.9004 7.70361 15.3603 7.70361 17.1603",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUser);
export default __webpack_public_path__ + "static/media/new-user.4f0a5d2a.svg";
export { ForwardRef as ReactComponent };